import { type Face, faceUrl } from "../face.ts";
import type { Paper } from "../requests.ts";
import styles from "./letter.module.css";

/**
 * A customer's letter on their paper (plain ruled paper without one): the body between 拝啓
 * and 敬具, who sent it (with their face, if known), and a postscript under that if there is
 * one.
 */
export function LetterPaper(
  { body, from, face, paper, postscript }: {
    body: string;
    from: string;
    face?: Face;
    paper?: Paper;
    postscript?: string;
  },
) {
  return (
    <div class={paper ? `${styles.paper} ${styles[paper]}` : styles.paper} data-from={from}>
      <p>拝啓　こねこ様</p>
      <div class={styles.body}>
        {body.split("\n").map((line, k) => <p key={k}>{line}</p>)}
      </div>
      <p class={styles.close}>敬具</p>
      <p class={styles.close}>
        {face && <img class={styles.face} src={faceUrl(face)} alt="" />}
        {from}より
      </p>
      {postscript && <p>追伸：{postscript}</p>}
    </div>
  );
}
